// extracted by mini-css-extract-plugin
export default {"description":"ProductDescription_description__mCCrm"};